import { Link } from "react-router-dom";

export default function Services (){
    return (
        <section className="services">
            <div className="section-title">Services</div>
            <div className="services-container">
                <div className="service">
                    <div className="title-container">
                        <div className="service-title">Web Backend</div>
                        <div className="service-price">from <span className="price">$899</span></div>
                    </div>
                    <div className="service-description">
                        Powerful And Scalable Web Backend Solutions Tailored To Your Needs. We Build Robust Architectures And Implement Functionalities That Form The Backbone Of Your Web Applications.
                    </div>
                    <div className="btn-container">
                        {/* btn-icon */}
                        <Link className="btn btn-getAservice">Start Project 
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    width="24"
                                    height="24"
                                    >
                                    <path
                                        d="M9.62 3.95312L13.6667 7.99979L9.62 12.0465"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M2.33337 8H13.5534"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                            </Link>
                    </div>
                </div>
                <div className="service">
                    <div className="title-container">
                        <div className="service-title">Web Development</div>
                        <div className="service-price">from <span className="price">$899</span></div>
                    </div>
                    <div className="service-description">
                        Comprehensive Web Development Services Bringing Your Ideas To Life. From Concept To Deployment, We Create Dynamic And Responsive Websites That Meet Your Business Objectives With Precision.    
                    </div>
                    <div className="btn-container">
                        <Link className="btn btn-getAservice">Start Project 
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    width="24"
                                    height="24"
                                    >
                                    <path
                                        d="M9.62 3.95312L13.6667 7.99979L9.62 12.0465"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M2.33337 8H13.5534"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                            </Link>
                    </div>
                </div>
                
            </div>
        </section>
    )
}